export const user_role_map = {
    1: 'Client',
    2: 'Auditor',
    3: 'Manager',
    4: 'FinancialManager',
    5: 'CEO',
    6: 'Admin'
};